import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { EMPTY_LIST } from '../../../constants/common'
import { MENU_COUNTER_ALIASES } from '../../../constants/menu'
import { useCounters, useInitData, useRefetchCounters } from '../../../hooks'
import { isDevelopmentEnvironment } from '../../../utils/common'
import { MenuItem } from '../MenuItem'
import { MenuItems } from '../MenuItems'
import { MenuSection } from '../MenuSection'

import * as styles from './PrimaryMenu.module.css'

function PrimaryMenu({
  className = styles.PrimaryMenu,
  collapsed = false,
  items = EMPTY_LIST,
}) {
  const location = useLocation()

  const { t } = useTranslation()

  const counters = useCounters()
  const { availableSections: sections } = useInitData()
  const refetchCounters = useRefetchCounters()

  useEffect(() => {
    refetchCounters()

    if (isDevelopmentEnvironment()) {
      console.log(`Pathname changed %c${location.pathname}`, 'color: blue')
    }
  }, [location.pathname])

  return (
    <MenuItems className={className}>
      {items.map((section, index) => (
        <MenuSection key={index}>
          {section.map(
            ({
              alwaysAvailable,
              blocked,
              icon: Icon,
              title,
              to,
              uiSectionName,
              webappTo,
              withoutCounter,
            }) => (
              <MenuItem
                Icon={Icon}
                blocked={blocked}
                collapsed={collapsed}
                counter={
                  (!withoutCounter && counters?.[MENU_COUNTER_ALIASES[to]]) || 0
                }
                isAvailable={alwaysAvailable || sections[uiSectionName]}
                key={to}
                text={t(title)}
                to={to}
                webappTo={webappTo}
              />
            )
          )}
        </MenuSection>
      ))}
    </MenuItems>
  )
}

export default PrimaryMenu
